var map = {
	"./large/concert_1.jpg": 9430,
	"./large/concert_2.jpg": 2558,
	"./large/guitar_1.jpg": 3166,
	"./large/guitar_2.jpg": 5951,
	"./large/guitar_3.jpg": 7386,
	"./large/guitar_4.jpg": 3045,
	"./large/guitar_5.jpg": 410,
	"./large/keyboard_1.jpg": 1718,
	"./large/keyboard_2.jpg": 3084,
	"./large/keyboard_3.jpg": 2882,
	"./list": 7117,
	"./list.json": 7117,
	"./medium/guitar_1.jpg": 8244,
	"./medium/keyboard_1.jpg": 6388,
	"./medium/keyboard_2.jpg": 8213,
	"./medium/pexels-cottonbro-studio-4088015.jpg": 7560,
	"./medium/pexels-emre-akyol-16822720.jpg": 8613,
	"./medium/pexels-jan-kopřiva-3858086.jpg": 4925,
	"./medium/pexels-rdne-stock-project-7503361.jpg": 1989,
	"./medium/pexels-rdne-stock-project-7503372.jpg": 4935,
	"./medium/pexels-roy-reyna-1835656.jpg": 5863,
	"./medium/pexels-roy-reyna-1835693.jpg": 2850,
	"./small/concert_1.jpg": 4835,
	"./small/concert_2.jpg": 5931,
	"./small/guitar_1.jpg": 4805,
	"./small/guitar_2.jpg": 1798,
	"./small/guitar_3.jpg": 9706,
	"./small/guitar_4.jpg": 6475,
	"./small/guitar_5.jpg": 8259,
	"./small/keyboard_1.jpg": 6705,
	"./small/keyboard_2.jpg": 6221,
	"./small/keyboard_3.jpg": 1190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1895;